
import { Component, Vue, Prop } from "vue-property-decorator";
import _ from "lodash-es";
import breadcrumbs from "@/lib/model/breadcrumb/breadcrumbs";
import Item from "@/lib/model/breadcrumb/item";
import Auth from "@/lib/common/auth";
import { CompanyConfig } from "@/lib/common/acm";

@Component({
  components: {}
})
export default class Breadcrumb extends Vue {
  @Prop({ type: Boolean, default: false }) paperInfo!: boolean;
  @Prop({ type: String, default: "" }) examName!: "";
  @Prop({ type: String, default: "" }) examRemark!: "";

  companyId = parseInt(Auth.companyId);
  showRemark = false;

  created() {
    const companyConfig = CompanyConfig.getInstance(this.companyId);
    this.showRemark = companyConfig.breadCrumbShowRemark == 1;
  }
  get items(): Item[] {
    let items: Item[] = [];
    const path = _.trim(this.$route.path, "/");
    if (breadcrumbs[path]) {
      items = breadcrumbs[path];
    } else {
      let maxLength = 0;
      for (const key in breadcrumbs) {
        if (_.startsWith(path, key)) {
          if (key.length > maxLength) {
            items = breadcrumbs[key];
            maxLength = key.length;
          }
        }
      }
    }
    //设置文案
    //if (items.length > 0) {
    //  title = items[items.length - 1].name + "-" + title;
    //}
    // document.title = title;
    return items;
  }
  goPath(item: Item) {
    //上一页
    if (item?.path === "-1") {
      this.$router.go(-1);
    } else if (item.path && item.path !== "") {
      this.$router.push(item.path + "?companyId=" + Auth.companyId);
    }
  }
}
